import { fetchApi } from '../api/digitalVault';
import { parseFileContainer, parseUserResponse } from '../utils';
const fetchUserMusicAlbums = async (params = {}, logger) => {
    const { albumsHolder } = await fetchApi(params, 'browse/audio/album', {}, false, logger);
    const cursor = albumsHolder.cursor?.$;
    return parseUserResponse(cursor, { file: parseFileContainer(albumsHolder.albums.album) }, () => fetchUserMusicAlbums(cursor ? { cursor } : params, logger));
};
export default fetchUserMusicAlbums;
